import {AlertIcon} from '@primer/octicons-react'
import {Blankslate} from '@primer/react/experimental'

export function PullRequestErrorState({text}: {text?: string}) {
  return (
    <div className="width-full">
      <Blankslate border={false} spacious={false}>
        <Blankslate.Visual>
          <AlertIcon size="medium" className="mb-2 fgColor-muted" />
        </Blankslate.Visual>
        <Blankslate.Heading>{text || 'Unable to load page.'}</Blankslate.Heading>
        <Blankslate.Description>
          <span className="d-flex flex-justify-center mt-2">{'The page is unavailable due to a system error.'}</span>
          <span className="d-flex flex-justify-center mt-2">
            {' Try reloading the page, or if the problem persists, contact support.'}
          </span>
          <span className="d-flex flex-justify-center mt-2">
            <a href={'https://www.githubstatus.com'}>{'GitHub status'}</a>
          </span>
        </Blankslate.Description>
      </Blankslate>
    </div>
  )
}
